export const en = {
  notFound: "Page not found",
  poweredBy: "powered by",
  clients: "clients",
  minutes: "minutes",
  totalMessage: "Nombre total de clients.",
  insideMessage: "Nombre de clients dans la queue.",
  waitingTimeMessage: "Temps d’attente.",
};
